/*__## CUSTOM JS ##__*/
document.addEventListener("DOMContentLoaded", function () {
    // Identifica il checkbox e il campo nascosto
    const checkbox = document.getElementById("accept_marketing_checkbox");
    const hiddenInput = document.getElementById("accepts_marketing_hidden");

    // Aggiorna il valore del campo nascosto quando il checkbox cambia
    if (checkbox){
      checkbox.addEventListener("change", function () {
        hiddenInput.value = checkbox.checked ? "true" : "false";
      });
    }
});

/*Calcolo altezza header*/
document.addEventListener("DOMContentLoaded", function () {
let headerBar = document.querySelector('sticky-header');
let headerBarHeight = headerBar.offsetHeight;
document.documentElement.style.setProperty('--header-bar-height',headerBarHeight + "px");
console.log("Header Bar Height Variable = --header-bar-height: ",headerBarHeight + "px");
});

document.querySelectorAll('a:has(span.external-link)').forEach(link => {
  link.setAttribute('target', '_blank');
  link.setAttribute('rel', 'noopener noreferrer');
});
